import { HttpService } from "@/core";
import { FileReq } from "@/core/services/biz-file.interface";

export class SignService {
  // 按钮弹窗，修改合同状态的公共接口
  static useContractStatusChangeApi() {
    const api = (files: FileReq[], bizId: string, bizType: string, bizFileType: string = '', contractStatus: string = '', operationDescType: string = '', operationDesc: string = '') =>
      HttpService.axios({
        method: "POST",
        url: `/common_api/contractStatusChange`,
        data: {bizId, bizType, fileObjAReq: { bizFiles: files, bizId, bizType:bizFileType,isAppend: 1 }, contractStatus, operationDescType, operationDesc},
      });
    return HttpService.useRequest(api);
  }
}
